<script setup lang="ts">
import Dragger from "./Dragger.vue";
import ToolOptionsDropdown from "./toolbar/ToolOptionsDropdown.vue";
import { DraggerType } from "@/drawing";
import DraggerMenuState from "@/stores/DraggerMenuState";
import AdditiveSelectionBtn from "./options/AdditiveSelectionBtn.vue";
import DisableToolBtn from "./options/DisableToolBtn.vue";
import Settings from "@/stores/Settings";
</script>

<template>
  <ToolOptionsDropdown :owners="[DraggerType.Select]">
    <template #tool>
      <Dragger
        :config="{ name: DraggerType.Select }"
        phosphor-icon="cursor"
        :tooltip-text="$t('canvas:tools.select.tooltip.text')"
        :tooltip-title="$t('canvas:tools.select.tooltip.title')"
        @click="DraggerMenuState.setActiveDragger({ name: DraggerType.Select })"
      />
    </template>
    <div
      class="btn-group-vertical rounded p-1"
      style="background-color: var(--canvas-bg)"
    >
      <DisableToolBtn v-if="!Settings.onlyStylusOn" />
      <AdditiveSelectionBtn />
    </div>
  </ToolOptionsDropdown>
</template>
